import { render, staticRenderFns } from "./SpinnerWheelContent.vue?vue&type=template&id=21b9a579&scoped=true&"
import script from "./SpinnerWheelContent.vue?vue&type=script&lang=js&"
export * from "./SpinnerWheelContent.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerWheelContent.vue?vue&type=style&index=0&id=21b9a579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b9a579",
  null
  
)

export default component.exports